<div class="enterprise-period-panel">
  @if (isSuperAdmin) {
    <mat-form-field appearance="outline">
      <mat-label>{{'MODELS.PARTNER.TEXT' | translate}}</mat-label>
      <mat-select [(value)]="selectedPartner" (selectionChange)="onPartnerSelected($event)">
        <mat-option [value]="" class="custom-mat-option"></mat-option>
        @for (partner of partners; track partner.id) {
          <mat-option [value]="partner.id" class="custom-mat-option">{{ partner.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <mat-form-field appearance="outline">
    <mat-label>{{'MODELS.COMPANY.TEXT' | translate}}</mat-label>
    <mat-select [disabled]="isSuperAdmin && (!selectedPartner || companies.length === 0)" [(value)]="selectedCompany" (selectionChange)="onCompanySelected($event)">
      <mat-option [value]="" class="custom-mat-option"></mat-option>
      @for (company of companies; track company) {
        <mat-option [value]="company.id" class="custom-mat-option">{{ company.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>{{'MODELS.ENTERPRISE.TEXT' | translate}}</mat-label>
    <mat-select [disabled]="!selectedCompany" [(value)]="selectedEnterprise" (selectionChange)="onEnterpriseSelected($event)">
      <mat-option [value]="" class="custom-mat-option"></mat-option>
      @for (enterprise of enterprises; track enterprise) {
        <mat-option [value]="enterprise.id" class="custom-mat-option">{{ enterprise.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>{{'MODELS.PLAN.PERIOD.TEXT' | translate}}</mat-label>
    <input matInput [value]="selectedPeriod" disabled>
  </mat-form-field>
</div>
